import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export function trackViewCart({
  cartTotalValue,
  currency,
  cartItems,
  viewLocation,
  marketplace_cart_type,
}: {
  cartTotalValue: number;
  currency: string;
  cartItems: Array<EcommerceCartItem | undefined>;
  viewLocation?: string;
  marketplace_cart_type?: string;
}) {
  pushToDataLayer({
    event: 'view_cart',
    type: viewLocation,
    ecommerce: {
      currency,
      value: cartTotalValue,
      marketplace_cart_type,
      items: cartItems,
    },
  });
}
